import {useQuery} from "@tanstack/react-query";
import React, {useCallback} from "react";
import {useSupportCase} from "../support/CaseHook";
import {useAuth} from "../auth/AuthHook";
import {useTranslation} from "react-i18next";
import {withBase} from "../utils/basePath";
import {LicenseUsageTracker} from "../license/LicenseUsageTracker";

interface PolicyLinks {
    privacy_policy_url?: string;
    terms_of_use_url?: string;
}

export function AppFooter() {
    const {fetchData} = useSupportCase();
    const {isLoggedIn} = useAuth();
    const  {t} = useTranslation();

    const fetchLinks = useCallback(async () => {
        const response = await fetchData("/api/server/policy_links", "GET");
        if (!response.ok) {
            return null;
        }
        return await response.json() as PolicyLinks;
    }, [fetchData])

    const {data: links, isLoading, error} = useQuery({
        queryKey: ['links', isLoggedIn()],
        queryFn: () => fetchLinks(),
        enabled: isLoggedIn(),
        staleTime: 5 * 60 * 1000,
    })

    if (!isLoggedIn() || isLoading || error != null) {
        return null;
    }

    return (
        <footer className="flex justify-evenly gap-4 py-1 px-4 text-xs text-gray-500">
            <div id="empty-start"/>
            <div id="policies flex flex-row gap-1">
                {links?.privacy_policy_url != null &&
                    <a href={links?.privacy_policy_url} target="_blank" rel="noopener noreferrer">{t("Privacy Policy")}</a>
                }
                {links?.terms_of_use_url != null &&
                    <a href={links?.terms_of_use_url} target="_blank" rel="noopener noreferrer">{t("Terms of Use")}</a>
                }
            </div>
            <div className={"flex flex-row gap-1 justify-center items-center"}>
                <span>
                    Powered by:
                </span>
                <img
                    src={withBase("/assets/artenai.png")}
                    alt="Arten.ai logo"
                    className="h-2 justify-self-center"
                />
                <LicenseUsageTracker />

            </div>


        </footer>
    )


}